import React, { useContext } from 'react';
import { compact } from 'lodash';

import Chapter from '../../Chapter';
import ChapterPlayerContext from '../../ChapterPlayer.context';
import { AssetType } from '../../../../utils/storage';

import LayeredMedia, {
    LayeredMediaProps,
    calculateDuration,
    calculateExitDuration,
} from './screens/LayeredMedia';

import './styles/fonts.scss';


export default class MediaChapter extends Chapter<LayeredMediaProps> {
    component = () => {
        const {
            width,
            height,
        } = useContext(ChapterPlayerContext);

        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    ['--hoi-font-vertical-correction' as string]: '1',
                }}
            >
                <LayeredMedia
                    {...this.data}
                    width={width}
                    height={height}
                    preventTransitions
                    languages={this.data.languages?.length ? this.data.languages : this.languages}
                />
            </div>
        );
    }

    fonts = [
        'helvetica-neue-hoi-ehq',
    ]

    canLoop = true

    calculateDuration() {
        return (calculateDuration(this.data) - calculateExitDuration(this.data)) / 1000;
    }

    getAssetsToCache(): AssetType[] {
        return compact(this.data.media || []).filter(media => media?.url);
    }
}
